import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes, requestType } from './constants';
import { RebootGatewayAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

function* RebootGatewaySaga({ gatewayID }) {
    yield put(RebootGatewayAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.rebootGateway, gatewayID);
        yield put(RebootGatewayAction(apiCallStatus.SUCCESS, response));
        if (response?.remoteCommandResponse?.requestType === requestType.TriggerNetaReboot) {
            notify(translate('ABB.Powertrain.Frontend.gatewayRebootGatewaySuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        }
        logger.debug('Gateway Rebooted Successfully : ', gatewayID);
    } catch (err) {
        yield put(RebootGatewayAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}
export function* RebootGatewayWatchers() {
    yield takeLatest(actionTypes.REBOOT_GATEWAY, RebootGatewaySaga);
}
